import { IAdFoxInfo } from '../../types/newbuilding';
import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectAdfoxInfo = (state: IApplicationState): IAdFoxInfo | null => {
  const { adfoxInfo } = selectNewbuilding(state);

  return adfoxInfo || null;
};
